import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WgInvoicesComponent } from './wg-invoices.component';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { QuickEditModule } from 'app/main/master-data/owners/quick-edit/quick-edit.module';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
  declarations: [WgInvoicesComponent],
  imports: [
    RouterModule,
    CommonModule,
    FuseSharedModule,
    FuseWidgetModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    QuickEditModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  exports: [WgInvoicesComponent]
})
export class WgInvoicesModule { }
